import { useContext } from 'react';
import FeeSetupContext from 'src/contexts/FeeSetupContext';

const useFeeSetup = () => useContext(FeeSetupContext);

export default useFeeSetup;
